<template>
  <section
    class="component-f39478b9"
    resmed-component-name="fullwidth_icon-line_text_overlay-intro"
  >
    <div
      class="component -transition-in-view"
      v-bind:class="{
        [`placement-${acf.layout['content-placement']}`]: true,
        [`text-color-${acf.layout['text-color']}`]: true,
        [`component-height-${acf.layout['component-height']}`]: true,
      }"
    >
      <figure
        class="embed-responsive"
        v-bind:class="{
          'embed-responsive-21by9': $root.mode === 'lg' || $root.mode === 'xl',
          'embed-responsive-16by9': $root.mode === 'md',
          'embed-responsive-33by40': $root.mode === 'xs' || $root.mode === 'sm',
        }"
      >
        <template v-if="acf.layout.background === 'image'">
          <div
            class="hero-bg embed-responsive-item"
            v-bind:style="styles"
          ></div>
        </template>

        <template v-if="acf.layout.background === 'video'">
          <background-video
            v-bind:file="video"
            v-bind:img="acf.layout.video_replacement"
            :key="componentKey"
          ></background-video>
        </template>

        <div class="wrapper px-xs-sm-2">
          <div class="container">
            <div class="row">
              <div
                class="col -in-view-slide-fade-lr"
                v-bind:class="{
                  'offset-md-1 col-md-7':
                    acf.layout['content-placement'] === 'left',
                  'col-md-8 offset-md-2':
                    acf.layout['content-placement'] === 'center',
                  'col-md-6 offset-md-6':
                    acf.layout['content-placement'] === 'right',
                }"
              >
                <eyebrow-icon
                  v-if="acf.eyebrowicon"
                  v-bind:eyebrowicon="acf.eyebrowicon"
                  v-bind:align="
                    acf.layout['content-placement'] === 'center' ? 'center' : ''
                  "
                ></eyebrow-icon>

                <figcaption>
                  <h1
                    class="display"
                    v-bind:class="{ '-has-eyebrow': acf.eyebrow }"
                    v-html="acf.headline"
                  ></h1>
                </figcaption>
                <div v-if="acf.introduction">
                  <div v-if="acf.introduction" v-html="acf.introduction"></div>
                </div>

                <!-- call to action -->
                <div v-if="acf.cta.length" class="mt-4">
                  <template v-if="acf.cta.length >= 1">
                    <!-- first cta, with modal option -->
                    <a
                      v-if="acf.modal.player"
                      href="#"
                      class="btn cta-pill filled-red icon right-arrow"
                      v-bind:modal-video-id="acf.modal.id"
                      v-on:click.prevent="modal(acf.modal.player, acf.modal.id)"
                      >{{ acf.cta[0].cta.text }}</a
                    >
                    <a
                      v-else
                      v-bind:href="acf.cta[0].cta.href"
                      v-bind:target="acf.cta[0].cta.target"
                      class="btn cta-pill filled-red icon right-arrow"
                      >{{ acf.cta[0].cta.text }}</a
                    >
                  </template>

                  <!-- second cta: optional. no modal -->
                  <a
                    v-if="acf.cta.length === 2"
                    v-bind:href="acf.cta[1].cta.href"
                    v-bind:target="acf.cta[1].cta.target"
                    class="btn cta-pill hallow-white icon right-arrow ml-2"
                    >{{ acf.cta[1].cta.text }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </figure>
    </div>
  </section>
</template>

<script>
import debounce from "lodash/debounce";
import backgroundVideo from "../shared-support/background-video";

export default {
  name: "component-f39478b9", // fullwidth_icon-line_text_overlay-intro
  props: ["acf"],
  components: {
    backgroundVideo,
  },
  data() {
    return {
      video: "", // video file
      componentKey: 0,
      styles: {
        "background-color": this.acf.layout["background-color"],
      },
    };
  },
  watch: {
    "$root.mode": {
      handler(val) {
        this.$set(
          this.styles,
          "background-image",
          `url(${this.acf.layout["background-image"]})`
        );

        if (
          ["xs", "sm"].includes(val) &&
          this.acf.layout["background-image-xs"]
        ) {
          this.$set(
            this.styles,
            "background-image",
            `url(${this.acf.layout["background-image-xs"]})`
          );
        }
      },
      immediate: true,
    },
  },
  methods: {
    modal(...arg) {
      bus.$emit("overlay:active", {
        active: true,
        player: arg[0],
        id: arg[1],
      });
    },
    forceRerender() {
      this.componentKey += 1;
    },
    debounce: debounce(function (arr) {
      // initial load
      if (!arr[1]) {
        this.video =
          arr[0] === "lg" || arr[0] === "xl"
            ? (this.video = this.acf.layout.video_16by9)
            : (this.video = this.acf.layout.video_4by3);

        this.forceRerender();
      }

      // from --> lg xl
      // to   --> xs sm md
      if (
        (arr[0] === "xs" || arr[0] === "sm" || arr[0] === "md") &&
        (arr[1] === "lg" || arr[1] === "xl")
      ) {
        this.video = this.acf.layout.video_4by3;
        this.forceRerender();
      }

      // from --> xs sm md
      // to --> lg xl
      if (
        (arr[0] === "lg" || arr[0] === "xl") &&
        (arr[1] === "xs" || arr[1] === "sm" || arr[1] === "md")
      ) {
        this.video = this.acf.layout.video_16by9;
        this.forceRerender();
      }
    }, 100),
  },
  created() {
    bus.$on("mode", (arr) => {
      this.debounce(arr);
    });

    bus.$emit("navigation:reversed", true);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-f39478b9 {
  // -->
}

.component {
  &.component-height-fixed {
    // --> default: based on embed-responsive ratio(s)
  }

  &.component-height-flex {
    .embed-responsive {
      &:before {
        display: none;
      }
    }

    .wrapper {
      position: relative;
      transform: none;
      padding: 24rem 0 4rem 0;

      @media (min-width: 992px) {
        min-height: 520px;
        padding: 12rem 0 6rem 0;
      }
    }
  }

  &.placement-center {
    text-align: center;

    h1 {
      &.-has-eyebrow {
        position: relative;
        @extend %eyebrow-center;
      }
    }
  }

  &.placement-left,
  &.placement-right {
    h1 {
      &.-has-eyebrow {
        position: relative;
        @extend %eyebrow-left;
      }
    }
  }

  &.text-color-black {
    h1 {
      color: $cc-resmed-black;

      &.-has-eyebrow {
        &:before {
          background-color: $cc-resmed-black;
        }
      }
    }

    .introduction * {
      color: $cc-resmed-black;
    }
  }

  &.text-color-white {
    h1 {
      color: rgba($cc-resmed-white, 0.875);

      &.-has-eyebrow {
        &:before {
          background-color: $cc-resmed-white;
        }
      }
    }

    .introduction * {
      color: $cc-resmed-white;
    }
  }

  h1 {
    margin: 0 0 1rem 0;
  }

  figure {
    background-color: $cc-resmed-dark-grey;

    .hero-bg {
      background-size: cover;
      background-position: right top;
      background-repeat: no-repeat;

      opacity: 0.7;

      @media (min-width: 992px) {
        background-size: cover;
        opacity: 1;
      }
    }
  }

  .wrapper {
    min-width: 100vw;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>